export default __webpack_public_path__ + "static/media/flpkrt.3a1a67f0.png";